export default __webpack_public_path__ + "static/media/error.0dacc3d2.png";